import React from 'react';
import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {
  TListOfElement,
  TTypeConstructor,
  TText,
  TRecord,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const SliderSlide = Atom.createRender(
  ({data, attributes, classes, generateAttributes, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
    const Tag = data.tag;
    const slideClasses = classes.push('w-slide');
    return (
      <Tag {...generateAttributes(attributes, slideClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: {type: 'Enumerated', value: 'Slide'},
  constraints: {
    parent: [
      {
        is: 'SliderMask',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Slider'), iconName('SliderSlide')),
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'Disabled to preserve slider functionality. If you need a different display setting for slider content, add a div block and style it instead.',
    },
  },
  showEmpty: true,
  render: SliderSlide,
  fields: {
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
    children: withSystem({private: true}, TListOfElement),
    slider: withSystem(
      {private: true},
      TRecord({
        type: TText,
      })
    ),
  },
});

export default config;
